import { queryOptions, UseQueryOptions } from '@tanstack/react-query'
import { BudgetingScenario } from '../../types/BudgetingScenario'
import { getBudgetingScenarioOptions } from './getBudgetingScenarioOptions'

type UseBudgetingScenarioOptionsProps<TData> = {
  companyId: string
  select?: (data: BudgetingScenario[]) => TData
}

export const useBudgetingScenarioOptions = <TData = BudgetingScenario[]>({
  companyId,
  select
}: UseBudgetingScenarioOptionsProps<TData>) => {
  return queryOptions(getBudgetingScenarioOptions(companyId, select)) as UseQueryOptions<TData>
}
